import { useParams, Navigate } from 'react-router-dom';
import { useState, useEffect } from 'react';
import projectsJSON from '../../data/projects.json';

// ethitech
import ethitech1 from "../../assets/images/projectimages/ethitech.png";
import ethitech2 from "../../assets/images/ethitech/ethitech2.png";
import ethitech3 from "../../assets/images/ethitech/ethitech3.png";
import ethitech4 from "../../assets/images/ethitech/ethitech4.png";
import ethitech5 from "../../assets/images/ethitech/ethitech5.png";
import ethitech6 from "../../assets/images/ethitech/ethitech6.jpg";

// greeneville
import greenevilledeli from "../../assets/images/projectimages/greeneville-deli.png";
import greenevilledeli2 from "../../assets/images/greeneville-deli/greeneville-deli2.png";
import greenevilledeli3 from "../../assets/images/greeneville-deli/greeneville-deli3.png";
import greenevilledeli4 from "../../assets/images/greeneville-deli/greeneville-deli4.png";

// world-app
import worldapp from "../../assets/images/projectimages/world-app.png";
import worldapp2 from "../../assets/images/world-app/world-app2.png";
import worldapp3 from "../../assets/images/world-app/world-app3.png";
import worldapp4 from "../../assets/images/world-app/world-app4.png";

// medical-clinic
import medical1 from "../../assets/images/projectimages/gallaghermedical.png";
import medical2 from "../../assets/images/medicalclinic/medical2.png";
import medical3 from "../../assets/images/medicalclinic/medical3.png";
import medical4 from "../../assets/images/medicalclinic/medical4.png";
import medical5 from "../../assets/images/medicalclinic/medical5.png";
import medical6 from "../../assets/images/medicalclinic/medical6.png";
import medical7 from "../../assets/images/medicalclinic/medical7.png";
import medical8 from "../../assets/images/medicalclinic/medical8.png";
import medical9 from "../../assets/images/medicalclinic/medical9.png";
import medical10 from "../../assets/images/medicalclinic/medical10.png";
import medical11 from "../../assets/images/medicalclinic/medical11.png";
import medical12 from "../../assets/images/medicalclinic/medical12.png";

const imageMap = {
    // ethitech
    "ethitech.png": ethitech1,
    "ethitech2.png": ethitech2,
    "ethitech3.png": ethitech3,
    "ethitech4.png": ethitech4,
    "ethitech5.png": ethitech5,
    "ethitech6.png": ethitech6,

    // greeneville
    "greeneville-deli.png": greenevilledeli,
    "greeneville-deli2.png": greenevilledeli2,
    "greeneville-deli3.png": greenevilledeli3,
    "greeneville-deli4.png": greenevilledeli4,

    // world-app
    "world-app.png": worldapp,
    "world-app2.png": worldapp2,
    "world-app3.png": worldapp3,
    "world-app4.png": worldapp4,

    //gallagher-medical
    "gallaghermedical.png": medical1,
    "medical2.png": medical2,
    "medical3.png": medical3,
    "medical4.png": medical4,
    "medical5.png": medical5,
    "medical6.png": medical6,
    "medical7.png": medical7,
    "medical8.png": medical8,
    "medical9.png": medical9,
    "medical10.png": medical10,
    "medical11.png": medical11,
    "medical12.png": medical12,
};


const Show = () => {
    const [project, setProject] = useState(null);
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedImage, setSelectedImage] = useState(null);
    const { slug } = useParams();

    // const Demo = lazy(() => import(`./demos/${project.demo}/App`));

    useEffect(() => {
        const found = projectsJSON.find((project) => project.slug === slug);
        setProject(found);
    }, [slug]);

    const openModal = (image) => {
        setSelectedImage(image);
        setIsModalOpen(true);
    };

    const closeModal = () => {
        setIsModalOpen(false);
        setSelectedImage(null);
    };

    if (project === null) return <h2>Loading...</h2>

    if (project === undefined) return <Navigate to={`/project/${slug}`} />

    return (
        <div className="container mx-auto px-4 py-4 min-h-screen">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
                <div>
                    <h1 className="text-7xl sm:text-5xl md:text-6xl lg:text-8xl font-extrabold break-words">{project.title}</h1>
                    <h3 className=" text-4xl mt-2">{project.description2}</h3>
                </div>
                <div>
                    <h3 className="text-2xl font-semibold mb-4">Screenshots</h3>
                    <div className="grid grid-cols-2 sm:grid-cols-3 gap-4">
                        {project.images.map((image, index) => (
                            <div key={index} className="flex flex-col items-center">
                                <img
                                    src={imageMap[image.url]}
                                    alt={image.caption}
                                    className="object-cover w-full h-48 sm:h-64 md:h-72 lg:h-80 rounded-lg transform transition-transform duration-300 hover:scale-105 cursor-pointer"
                                    onClick={() => openModal(imageMap[image.url])}
                                />
                                <p className="mt-2 text-lg">{image.caption}</p>
                            </div>
                        ))}
                    </div>
                </div>
            </div>

            {isModalOpen && (
                <div className="fixed inset-0 flex items-center justify-center bg-black bg-opacity-75 z-50">
                    <div className="relative max-h-[90vh] max-w-[90vw] overflow-auto bg-white p-4 rounded-lg">
                        <button className="absolute top-0 left-0 m-4 text-black text-2xl" onClick={closeModal}>&times;</button>
                        <img src={selectedImage} alt="Expanded" className="max-w-full max-h-full" />
                    </div>
                </div>
            )}
        </div>
    );
};

export default Show;